import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import { withTranslation, Trans } from 'react-i18next';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import amplitude from 'amplitude-js';
import smartlookClient from 'smartlook-client';
import { Link } from 'react-router-dom';
import { LoginButton } from '../components/LoginButton';
import * as types from '../constants/ActionTypes';
import { VCS_SLUG, resolveVcs } from '../constants/api';
import { API_REST_URL, GA_WEBSITE, GHA_SLUG, IS_APP_CODEAC, PUBLIC_URL, VCS as ENV_VCS } from '../constants/env';
import Authenticator from '../containers/Authenticator';
import Icon from '../components/Icon';
import withGTag from '../components/withGTag';
class LoginPage extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            vcs: null,
        };
        this.login = (vcs, custom = null) => {
            this.setState({ vcs: vcs });
            this.props.dispatch({ type: types.AUTHENTICATING_USER });
            if (custom) {
                localStorage.setItem('customVcs', custom);
            }
            this.props.gtag('event', vcs, {
                event_category: 'sign-in',
                send_to: GA_WEBSITE,
            });
            this.props.gtag('event', 'conversion', {
                send_to: 'AW-792752718/2KRHCNqj54gBEM7kgfoC', // @todo: remove hardcoded string
            });
            sessionStorage.removeItem('noTrack');
            const utmCampaign = new URL(location.href).searchParams.get('utm_campaign');
            // @ts-expect-error TS2322: Type 'string' is not assignable to type 'Location | (string & Location)'.
            window.location =
                API_REST_URL +
                    '/auth/' +
                    vcs +
                    (vcs === 'github' && ((IS_APP_CODEAC && GHA_SLUG) || /[&?]gha(&|$)/.test(location.search)) ? '/app' : '') +
                    (custom ? '?vcs=' + custom : '') +
                    (utmCampaign ? (custom ? '&' : '?') + 'utm_campaign=' + utmCampaign : '');
        };
    }
    UNSAFE_componentWillReceiveProps( /*props: Props*/) {
        const params = window.location.hash.split('&');
        if (params.length > 1 && params[0].startsWith('#access_token=') && params[1].startsWith('vcs=')) {
            this.setState({ vcs: params[1].replace('vcs=', '') });
        }
        if (window.location.hash.split('&').includes('noTrack') ||
            window.location.hash.split('&').includes('#noTrack')) {
            sessionStorage.setItem('noTrack', '1');
        }
    }
    render() {
        const { user, match, t } = this.props;
        const publicUrl = PUBLIC_URL;
        const siteName = t('siteName');
        document.title = siteName;
        if (user.loggedIn) {
            if (!localStorage.getItem('ampLoginSent')) {
                const userId = user.user.id.toFixed(0).padStart(5, '0');
                const eventName = 'login';
                const eventProperties = {
                    vcs: VCS_SLUG[user.user.vcs],
                };
                const userProperties = {
                    vcs: VCS_SLUG[user.user.vcs],
                    planName: user.user.plan.name,
                    planTrial: user.user.plan.trialExpirationDate,
                    planAnnually: user.user.plan.annuallyPayment,
                };
                amplitude.getInstance().setUserProperties(userProperties);
                amplitude.getInstance().setUserId(userId);
                amplitude.getInstance().logEvent(eventName, eventProperties);
                smartlookClient.track(eventName, eventProperties);
                smartlookClient.identify(userId, userProperties);
                localStorage.setItem('ampLoginSent', '1');
            }
            if (localStorage.getItem('loginRedirectUrl')) {
                const redirectUrl = String(localStorage.getItem('loginRedirectUrl'));
                localStorage.removeItem('loginRedirectUrl');
                return _jsx(Redirect, { to: redirectUrl });
            }
            return _jsx(Redirect, { to: "/repositories" });
        }
        else if (match.params.slug && !(Object.values(VCS_SLUG).includes(match.params.slug))) {
            return _jsx(Redirect, { to: "/login" });
        }
        else {
            localStorage.removeItem('ampLoginSent');
        }
        const params = window.location.hash.split('&');
        const gitlabError = params.length > 0 && params[0] === '#error' && params[1] === 'vcs=gitlab';
        const gitlabTosError = params.length > 0 && params[0] === '#auth_failed' && params[1] === 'code=403';
        const vcsName = resolveVcs(match.params.slug);
        const isDark = document.documentElement.classList.contains('dark');
        return (_jsxs("div", { className: IS_APP_CODEAC ? 'content--login' : '', children: [_jsx(Authenticator, { checkLogin: true, match: match }), _jsx("div", { className: "container", children: _jsxs("div", { className: "login", children: [_jsx("h2", { className: "login__title", children: _jsx("img", { src: `${publicUrl}images/codeac-header${isDark ? '_dark' : ''}.svg`, alt: siteName, height: "52" }) }), _jsxs("div", { className: "login__flex", children: [_jsxs("div", { className: "login__text-wrapper", children: [_jsx("div", { className: "login__icon-wrap", children: _jsx("a", { href: "https://www.codeac.io/infrastructure-as-code.html?utm_campaign=login-whats-new", target: "_blank", children: _jsx(Icon, { name: "kubernetes", size: "3x" }) }) }), _jsxs("div", { className: "text-container", children: [_jsx("span", { className: "what-is-new", children: t('whatsNew') }), _jsx("h2", { className: "login__text-wrapper__title", children: t('analyzeIaC') }), _jsx("p", { className: "login__text-wrapper__text", children: _jsxs(Trans, { i18nKey: "analyzeIaCdescription", values: { siteName: t('siteName') }, children: ["Boost your DevOps pipeline to the next level with ", t('siteName'), ". Analyze ", _jsx("strong", { children: "Terraform" }), ", ", _jsx("strong", { children: "Ansible" }), ", ", _jsx("strong", { children: "Kubernetes" }), ", ", _jsx("strong", { children: "CloudFormation" }), " and much more. Catch security issues and improve best practices across your infrastructure."] }) }), _jsx("a", { href: "https://www.codeac.io/infrastructure-as-code.html?utm_campaign=login-whats-new", target: "_blank", children: t('checkOutMore') })] })] }), _jsx("div", { className: "login__button-wrapper", children: user.authenticating ? (_jsxs("button", { className: "btn btn-light btn-lg", disabled: true, children: [!this.state.vcs ? null : _jsx(Icon, { name: this.state.vcs, className: "mr-2" }), t('sign.signing'), _jsx(Icon, { name: "spinner", pulse: true, fixedWidth: true, className: "ml-2" })] })) : !match.params.slug ? (ENV_VCS ? (_jsx("div", { className: "login__buttons", children: _jsx(LoginButton, { onClick: () => {
                                                    // @ts-expect-error TS2538: Type 'null' cannot be used as an index type.
                                                    return this.login(VCS_SLUG[ENV_VCS]);
                                                }, vcs: VCS_SLUG[ENV_VCS], text: t('sign.in') }) })) : (_jsxs("div", { className: "login__buttons", children: [_jsx("h2", { className: "h4 mb-3", children: t('sign.inWith') }), ['bitbucket', 'github', 'gitlab'].map(vcsIdentifier => _jsx(LoginButton, { onClick: () => this.login(vcsIdentifier), vcs: vcsIdentifier, text: t(vcsIdentifier) }))] }))) : (_jsxs("div", { className: "login__buttons", children: [_jsx(LoginButton, { onClick: () => this.login(vcsName, match.params.slug), vcs: vcsName, text: t('sign.inWith' + vcsName.slice(0, 1).toUpperCase() + vcsName.slice(1)) }), _jsx(Link, { to: "/login", className: "login__link-to-other-service", children: t('sign.signingOther') })] })) })] }), gitlabError && _jsx("div", { className: "alert alert-danger", children: t('gitlabCommunicationFailed') }), gitlabTosError && (_jsx("div", { className: "alert alert-danger w-75 ml-auto mr-auto mb-5", children: t('gitlabTosError') }))] }) })] }));
    }
}
const mapStateToProps = (state) => ({
    user: state.user,
});
const mapDispatchToProps = (dispatch) => ({
    dispatch: dispatch,
});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(withGTag(LoginPage)));
